import { observer } from 'mobx-react-lite'
import { type WorkspaceInvitationModalViewModel } from '@/features/opportunities/invitations/WorkspaceInvitationModalViewModel'
import { WorkspaceInvitationModal } from '@/features/opportunities/invitations/components/WorkspaceInvitationModal'

export interface WorkspaceInvitationModalContainerProps {
  vm: WorkspaceInvitationModalViewModel
}

export const WorkspaceInvitationModalContainer = observer(
  function WorkspaceInvitationModalContainer({
    vm,
  }: WorkspaceInvitationModalContainerProps) {
    return (
      <WorkspaceInvitationModal
        id={vm.id}
        showing={vm.modal.showing}
        software={vm.software}
        location={vm.location}
        specs={vm.specs}
        description={vm.description}
        timeUntilExpiration={vm.timeUntilExpiration}
        isAcceptPending={vm.accept.pending}
        onAccept={vm.accept}
        isRejectPending={vm.reject.pending}
        onReject={vm.reject}
      />
    )
  },
)
